import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import LocaleStrings from "@language";

const TicketTags = (props) => {
  const { ticketTags } = props;

  const selectTag = (tag) => {
    // console.log("tag :- ", tag);

    props.handleSelectTag(tag);
  };

  const renderTags = () => {
    return _.map(ticketTags, (tag, index) => {
      return (
        <li
          key={`ticket_tag_${index}`}
          className="overflow-hidden shadow-sm rounded-xl border border-default hover:shadow"
          onClick={() => selectTag(tag)}
        >
          <div className="px-6 py-4 text-center break-all cursor-pointer custom-text-primary-lg-bold">
            {tag === "other" ? LocaleStrings.kOtherTickets : tag}
          </div>
        </li>
      );
    });
  };

  // console.log("ticketTags :- ", ticketTags);

  return (
    <ul role="list" className="grid grid-cols-2 gap-x-6 gap-y-6 md:grid-cols-3">
      {renderTags()}
    </ul>
  );
};

const mapStateToProps = (state) => {
  let ticketTags = state?.ticketLists?.tickettags;
  let otherTagsArr = _.filter(
    state?.ticketLists?.data,
    (obj) => !obj.tickettag || obj.tickettag === ""
  );
  // console.log("otherTagsArr :- ", otherTagsArr);
  if (otherTagsArr?.length > 0 && _.indexOf(ticketTags, "other") === -1) {
    ticketTags.push("other");
  }

  return {
    ticketTags: ticketTags,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketTags);
